export const hasDivider = (current: number, entries: unknown[]) => current < entries.length - 1;
